<template>
  <div class="fieldset-name-parts">
    <label>
      <span class="label-text">{{ $t('formParts.label.name') }}</span>
      <span class="required" v-if="required">{{ $t('formParts.required') }}</span>
    </label>
    <ValidationProvider
      slim
      name="name"
      rules="required|max:32"
      v-slot="{ errors }"
      vid="familyName"
    >
      <atom-input-text
        class="fieldset-name-parts__input"
        :placeholder="$tc('formParts.placeholder.nameFamily')"
        v-model="familyName"
        :error="errors.length > 0"
        @enter="emitEnter"
      />
    </ValidationProvider>
    <ValidationProvider
      slim
      name="name"
      rules="required|max:32"
      v-slot="{ errors }"
      vid="firstName"
    >
      <atom-input-text
        class="fieldset-name-parts__input"
        :placeholder="$tc('formParts.placeholder.nameFirst')"
        v-model="firstName"
        :error="errors.length > 0"
        @enter="emitEnter"
      />
    </ValidationProvider>

    <form-error-message-parts
      :showError="showError"
      :message="errorMessage !== '' ? errorMessage : $t('formParts.errorMessage.name')"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import AtomInputText from '@/components/atoms/input/AtomInputText.vue'
import FormErrorMessageParts from '@/components/common/form/FormErrorMessageParts.vue'

/**
 * フィールドセット 名前入力 バーツ
 * todo: 正常なsetup / emit処理 /
 */
export default defineComponent({
  name: 'FieldsetNameParts',
  components: {
    AtomInputText,
    FormErrorMessageParts,
  },
  props: {
    /**
     * 入力データ
     */
    valueFamily: {
      type: String,
      default: '',
    },
    valueFirst: {
      type: String,
      default: '',
    },
    /**
     * 必須フラグ
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーフラグ
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーメッセージ
     */
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    /**
     * familyName
     * @param {string} val 姓(漢字)
     */
    const familyName = computed({
      get: () => props.valueFamily,
      set: (val: string) => context.emit('inputfamilyName', val),
    })
    /**
     * firstName
     * @param {string} val 名(漢字)
     */
    const firstName = computed({
      get: () => props.valueFirst,
      set: (val: string) => context.emit('inputfirstName', val),
    })
    return {
      familyName,
      firstName,
    }
  },
  methods: {
    /**
     * Enter Push
     */
    emitEnter() {
      /**
       * Enterボタン押下を通知する
       * @event login
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
</script>

<style lang="scss" scoped>
.fieldset-name-parts {
  @include fieldSet();

  &__input {
    width: calc(50% - 4px);
  }
}
</style>
